<template>
    <div class="mt-vanilla-tilt col-lg-2 col-md-3 col-sm-4 col-4 mt-4">
        <router-link :to="itemData.url">
            <div class="lazy square" :data-bg="itemData.thumbnail">
                <div class="mt-offer-thumbnail-inner">
                    <h5 class="mt-f-bold text-uppercase">{{itemData.title}}</h5>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
    import VanillaTilt from "vanilla-tilt";
    import $ from "jquery";

    export default {
        name: "OfferCarouselItemBottom",
        props: {
            itemData: {}
        },
        data() {
            return {}
        },
        mounted() {
            VanillaTilt.init(document.querySelectorAll('.mt-vanilla-tilt'), {
                max: 15
            });
            $('#mt-offer-squares .square').mouseenter(function () {
                $("#mt-offer-carousel")
                    .unbind()
                    .carousel($(this).index('#mt-offer-squares .square'));
            })
        }
    }
</script>

<style scoped>
    .mt-offer-thumbnail-inner {
        position: absolute;
        left: 50%;
        bottom: 10px;
    }

    @media (max-width: 768px) {
        .mt-offer-thumbnail-inner > h5 {
            font-size: medium;
        }
    }
</style>